<template>
    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>
        <div class="clearfix mb-4" v-if="buttonAddRoute">
            <button-route class="float-end" :items="buttonRouteAdd"/>
        </div>

        <form v-if="showView">
            <div class="aux my-4">
                <div class="avatar-form">
                    <img v-if="formData.photo" :src="formData.photo" alt="" class="avatar__image">
                    <img v-else src="@/assets/images/avatar.png" alt="" class="avatar__image">
                </div>
                <p>{{ formData.name }}</p>
            </div>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.name}">
                    <label>Nome:</label>
                    <input-component disabled :type-input="'text'" v-model="formData.name"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.balance}">
                    <label>Saldo:</label>
                    <input-component disabled :type-input="'text'" v-model="formData.balance"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.status}">
                    <label>Status:</label>
                    <Multiselect disabled v-model="formData.status" :options="selectActiveInative" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.bank}">
                    <label>Banco:</label>
                    <Multiselect disabled v-model="formData.bank" :options="selectBankList" :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.account_type}">
                    <label>Tipo de Conta:</label>
                    <Multiselect disabled v-model="formData.account_type" :options="selectAccountTypeList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.agency}">
                    <label>Agência:</label>
                    <input-component disabled :type-input="'text'" v-model="formData.agency"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.digit_account}">
                    <label>Conta/Dígito:</label>
                    <input-component disabled :type-input="'text'" v-model="formData.digit_account"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                        :class="{'formError' : errors.pix_type}">
                    <label>Tipo de PIX:</label>
                    <Multiselect disabled v-model="formData.pix_type" :options="selectPIXList"
                                 :searchable="true"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.key_pix}">
                    <label>Chave:</label>
                    <input-component disabled :type-input="'text'" v-model="formData.key_pix"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                   :class="{'formError' : errors.obs}">
                    <label>Observações:</label>
                    <input-text-area disabled :rows="4" v-model="formData.obs"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-4'">
                    <label>Conta principal?</label>

                    <input disabled v-model="formData.main_account" type="radio" name="docs" id="main-account-no"
                           value="1">
                    <label for="main-account-no">Não</label>

                    <input disabled v-model="formData.main_account" type="radio" name="docs" id="main-account-yes"
                           value="2">
                    <label for="main-account-yes">Sim</label>
                </row-col-component>

                <row-col-component
                        :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-4'">
                    <label>Permitir saldo negativo?</label>

                    <input disabled v-model="formData.allow_negative_balance" type="radio" name="docs-two"
                           id="allow-negative-no"
                           value="1">
                    <label for="allow-negative-no">Não</label>

                    <input disabled v-model="formData.allow_negative_balance" type="radio" name="docs-two"
                           id="allow-negative-yes"
                           value="2">
                    <label for="allow-negative-yes">Sim</label>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <button-route :items="buttonRoute" style="width: 100%;"/>
                </row-col-component>
            </row-component>
        </form>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import InputTextArea from '@/components/form/InputTextArea';
import ErrorComponent from "@/components/alerts/ErrorComponent";
import {useToast} from "vue-toastification";

const toast = useToast()
export default {
    name: 'AccountBankShow',

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Conta Bancária')
        this.checkACL()
        this.loadAccountBank()
    },

    components: {
        ErrorComponent,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonRoute,
        InputTextArea
    },

    data() {
        return {
            itensOne: {
                title: "Ver",
                icon: "ti-eye"
            },

            buttonRoute: {
                icon: 'ti-arrow-back-up',
                route: '/account-bank/search',
                name: 'Voltar'
            },

            formData: {
                name: '',
                bank: '',
                balance: '',
                account_type: '',
                agency: '',
                digit_account: '',
                pix_type: '',
                key_pix: '',
                allow_negative_balance: 1,
                main_account: 1,
                status: '',
                obs: ''
            },

            errors: [],
            showView: false,
            sendForm: false,
            showError: false,
        }
    },

    methods: {

        loadAccountBank() {
            this.$store.dispatch('loadAccountBank', this.id)
                .then((r) => {
                    this.formData = r
                }).catch(() => {
                toast.error("Erro desconhecido!", {timeout: 2000});
            })
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 15)
                .then((r) => {
                    if (r.data.indexOf('account-bank-search') !== -1) {
                        this.showView = true

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectAccountTypeList() {
            return this.$store.state.var.selectAccountTypeList
        },

        selectBankList() {
            return this.$store.state.var.selectBankList
        },

        selectPIXList() {
            return this.$store.state.var.selectPIXList
        }
    }

}
</script>